import React from "react";

import { Outlet } from "react-router-dom";
import Div100vh from "react-div-100vh";
import { Toaster } from "./ui/toaster";

const Layout = () => {
 
  // useEf
  //   // Start with the slide-out state
  //   // setSlideIn(false);

  //   // Delay to allow the slide-out effect before showing the new content
  //   const timeoutId = setTimeout(() => {
  //     // setSlideIn(true); // Slide in the new content
  //   }, 100); // Small delay to allow the component to start the transition

  //   // Cleanup timeout on unmount or location change
  //   return () => clearTimeout(timeoutId);
  // }, [location]);

  return (
    <Div100vh
      className={`bg-black flex justify-center items-center transition-transform duration-1000 select-none`}>
      <div className="w-full max-w-lg rounded-md shadow-md sm:max-w-lg md:max-w-lg lg:max-w-md">
        <Outlet />
        <Toaster/>
      </div>
      
    </Div100vh>
  );
};

export default Layout;
